module.exports = __webpack_public_path__ + "static/media/TextBlack.2782be07.svg";